


import { Vue, Component, Prop, Watch, Emit, Ref } from "vue-property-decorator";
import {
  MerchFoodForBusinessDto,
  MerchFoodForBusiness,
  MerchFoodStatus
} from "../../../types/interface/Food/foodTypes";

@Component
export default class BaseMenu extends Vue {
  // exit stock
  showStockModal: boolean = false;
  openStockModal(food: MerchFoodForBusinessDto) {
    this.showStockModal = true;
    this.currentItem = food;
    this.stock = this.currentItem.stock;
  }

  closeStockModal() {
    this.showStockModal = false;
    this.currentItem = MerchFoodForBusiness;
    this.stock = 0;
  }

  closeItemActiveModal() {
    this.showItemActiveModal = false;
    this.currentItem = MerchFoodForBusiness;
    this.foodStatus = MerchFoodStatus.OffSale;
  }

  foodStatus: MerchFoodStatus = MerchFoodStatus.OffSale;

  openItemActiveModal(food: MerchFoodForBusinessDto) {
    this.showItemActiveModal = true;
    this.currentItem = food;
    this.foodStatus = food.status;
  }

  showUntilSpecificTimeModal: boolean = false;
  dateTime: string = "";

  minDatetime() {
    return new Date().toISOString();
  }

  openUntilSpecificTime() {
    this.showItemActiveModal = false;
    this.showUntilSpecificTimeModal = true;
  }

  closeUntilSpecificTimeModal() {
    this.currentItem = MerchFoodForBusiness;
    this.showUntilSpecificTimeModal = false;
    this.dateTime = "";
  }

  stock: number = 0;
  rules: { [key: string]: (value: any) => boolean | string } = {
    required: (value: number | string) => value !== "" || "Required.",
    counter: (value: number) =>
      (value * 1 < 10000 && value * 1 > -1) ||
      "Max 10000 number or min 0 number"
  };

  // 上下架
  showItemActiveModal: boolean = false;

  currentItem: MerchFoodForBusinessDto = MerchFoodForBusiness;
}
